/**
 * Helper for enumerating a type from a const object
 * Example: export type Foo = ValuesOf\<typeof Foo\>
 * @public
 */
export type ValuesOf<T> = T[keyof T];

// returns the active element in the shadow context of the element in question.
export function getRootActiveElement(element: Element): Element | null {
    const rootNode = element.getRootNode();

    if (rootNode instanceof ShadowRoot) {
        return rootNode.activeElement;
    }

    return document.activeElement;
}
